export default "__VITE_ASSET__f3734c9a__"